export enum LinkedToOrderBatchOption {
    All = 0,
    LinkedOnly = 1,
    NotLinkedOnly = 2
}